import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import MessageCenter from './pages/MessageCenter';
import {useEffect} from "react";
import ProtectedRoute from "./libs/ProtectedRoute";

function App() {

    useEffect(() => {
        const api = JSON.parse(localStorage.getItem('api'));
        if(!api){
            window.location.href = 'https://falcon.petrolsolutions.com/';
        }
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<ProtectedRoute><MessageCenter/></ProtectedRoute>}>
                    <Route path=":slug" element={<ProtectedRoute><MessageCenter/></ProtectedRoute>} />
                </Route>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
            </Routes>
        </Router>
    );
}

export default App;
